import {
  baseUrl,
  baseUrl_tDocumento,
  baseUrl_trabajador,
  baseUrl_empresa,
  JWT,
  valortotalDocumentosSeleccionados,
  XHR,
} from "../helpers";

import {
  Idocumento,
  ServiciosVentas,
  TiposDocumentos,
  payLoadDatosMaestros,
  payLoadPagoRapido,
  Iestado,
  detallePago,
} from "../helpers/dataExamples";

import { StepperComponent } from "../components";
import Swal from "sweetalert2";

const defaultState: Iestado = {
  showError: false,
  showDetail: false,
  tipoDocumento: "C.C",
  documento: "" /*"1050951157" "8904800237", "78713322",*/,
  correo: "",
  telefono: "",
  nombres: "",
  apellidos: "",
  direccion: "",
  servicio: "ninguno",
  guidTransaccion: null,
  sessionId: "",
  idServicio: null,
  referenciaActiva: "",
  fechaVencimiento: "",
  referencias: {},
};

const cargarDatosMaestros = async (payLoad: payLoadDatosMaestros) => {
  const consultarTiposDocumentos = async () => {
    const token = await JWT("PAGOS_EN_LINEA");
    var _headers = { Authorization: "Bearer " + token };
    var url = baseUrl_tDocumento()+"";
    var resp = await XHR(
      payLoad.setPantallaBloqueada,
      url,
      {},
      "get",
      _headers
    );
    if (resp?.data.exito) {
      //const newState = { ...tiposDocumentosDisponibles };
      resp.data.data.forEach((t: any) => {
        var tdocumento: TiposDocumentos = {
          codigo: t.abreviatura,
          abreviatura: t.abreviatura,
          descripcion: t.descripcion,
        };
        payLoad.tiposDocumentos.push(tdocumento);
      });
      payLoad.setTiposDocumentosDisponibles([...payLoad.tiposDocumentos]);
    }
  };

  const consultarServiciosVenta = async () => {
    const token = await JWT("PAGOS_EN_LINEA");
    var _headers = { Authorization: "Bearer " + token };
    var url = baseUrl() + "ServiciosVentas/listarServicioVentas";
    var response = await XHR(
      payLoad.setPantallaBloqueada,
      url,
      {},
      "get",
      _headers
    );
    if (response?.data.exito) {
      response.data.data.forEach((srv: any) => {
        var servicio: ServiciosVentas = {
          id: srv.id,
          nombre: srv.nombre,
          abonable: srv.abonable,
          porcentajeAbono: srv.porcentajeAbono,
          codigoServicio: srv.codigoServicio,
          codigoServicioSap: srv.codigoServicioSap,
        };
        payLoad.serviciosVentas.push(servicio);
      });
      payLoad.setServiciosVentasDisponibles([...payLoad.serviciosVentas]);
    }
  };

  consultarTiposDocumentos();
  await consultarServiciosVenta();

  //SI HAY UN ENLACE A PAGO RAPIDO SE EJECUTA LA FUNCIONALIDAD DE PAGO RAPIDO
  if (payLoad.parametrosURL.idpago) {
    const payLoadpr: payLoadPagoRapido = {
      idpago: payLoad.parametrosURL.idpago,
      estado: payLoad.estado,
      stepper: payLoad.stepper,
      serviciosVentas: payLoad.serviciosVentas,
      setPantallaBloqueada: payLoad.setPantallaBloqueada,
      setEstado: payLoad.setEstado,
      setStepIndex: payLoad.setStepIndex,
      setErrorMensaje: payLoad.setErrorMensaje,
      setShowError: payLoad.setShowError
    };

    consultarPagoRapido(payLoadpr);
  }
};

const consultarDocumentosPagoPersona = async (
  estado: Iestado,
  stpb: React.Dispatch<React.SetStateAction<boolean>>,
  documentosPago: Idocumento[],
  setDocumentosPagoDisponibles: React.Dispatch<
    React.SetStateAction<Idocumento[]>
  >,
  setEstado: React.Dispatch<React.SetStateAction<Iestado>>
) => {
  var data = {
    I_CEDULA: estado.documento,
    I_TIPO_DOCUMENTO: estado.tipoDocumento.replace(".", ""),
    I_TIPO_ELEMENTO: "TODOS",
  };

  setDocumentosPagoDisponibles([]);
  const newState = { ...estado };
  newState.referencias = {};
  newState.referenciaActiva = "";
  setEstado(newState);

  const token = await JWT("PAGOS_EN_LINEA");
  var _headers = { Authorization: "Bearer " + token };
  var resp = await XHR(
    stpb,
    baseUrl() + "Transacciones/consultarDocumentosPago",
    data,
    "post",
    _headers
  );
  if (typeof resp?.data.data == "undefined") {
    /*payLoad.setErrorMensaje(
      "No hay documentos disponibles para pago usando este tipo de servicio, seleccione otro!"
    );*/
    //payLoad.setShowError(true);
  } else if (Object.keys(resp?.data.data).length === 0) {
    /*payLoad.setErrorMensaje(
      "No hay documentos disponibles para pago usando este tipo de servicio, seleccione otro!"
    );
    payLoad.setShowError(true);*/
  } else if (resp?.data.exito) {
    resp.data.data.forEach((row: any) => {
      var documento: Idocumento = {
        referencia: row.reference,
        valorMinimo: row.ammount,
        valorTotal: parseInt(row.total_ammount),
        detalle: row.description,
        vence: row.date_due,
        codigoServicio: row.mensaje_v1,
        trans_bloq: row.trans_bloq
      };
      documentosPago.push(documento);
    });
    setDocumentosPagoDisponibles([...documentosPago]);
  }
};

const consultarPagoRapido = async (payLoad: payLoadPagoRapido) => {
  var response = await XHR(
    payLoad.setPantallaBloqueada,
    baseUrl() + "PagoRapido/consultarPagoRapido/" + payLoad.idpago,
    {},
    "get"
  );

  const newState = { ...payLoad.estado };

  if (response?.data.exito) {
    const resp = response.data.data;
    const referencia = resp.referencia;

    newState.documento = resp.documento;
    newState.tipoDocumento = resp.tipoDocumento;

    var newReferencia: detallePago = {
      abonable: false,
      descrip: resp.descrip,
      hacer_abono: false,
      limite: resp.limite.split("T")[0],
      porMinimoAbono: 0,
      referencia: resp.referencia,
      valorTotal: resp.valor,
      valorMinimo: resp.valor,
      valorMinimoAbono: 0,
      valor_abono: 0,
      codigoServicio: resp.servicio,
      codigoServicioSAP: resp.servicioSap,
      idServicio: null,
      fechaVencimiento: "",
      tipoPago: "min"
    };

    const aa = { [referencia]: newReferencia };
    Object.assign(newState.referencias, aa);

    let tipoServicio = payLoad.serviciosVentas.find(
      (srv) => srv.codigoServicio === resp.servicio
    );

    let minimoAbono =
      typeof tipoServicio?.porcentajeAbono != "undefined"
        ? (resp.valor * tipoServicio?.porcentajeAbono) / 100
        : 0;

    let idServicio =
      typeof tipoServicio?.id != "undefined" ? tipoServicio?.id : "";

    newState.sessionId = resp.sessionId;
    newState.idServicio = idServicio;
    newState.referenciaActiva = referencia;
    newState.nombres = resp.nombres;
    newState.apellidos = resp.apellidos;
    newState.telefono = resp.telefono;
    newState.correo = resp.correo;

    newState.referencias[referencia].valorMinimoAbono = minimoAbono;
    newState.referencias[referencia].referencia = resp.referencia;
    newState.referencias[referencia].descrip = resp.descrip;
    newState.referencias[referencia].valorTotal = resp.valor;
    newState.referencias[referencia].valorMinimo = resp.valor;
    newState.referencias[referencia].limite = resp.limite.split("T")[0];
    newState.referencias[referencia].abonable =
      typeof tipoServicio?.abonable != "undefined";
    newState.referencias[referencia].codigoServicio = resp.servicio;
    newState.referencias[referencia].codigoServicioSAP = resp.servicioSap;

    //console.log(newState.referencias[referencia]);
    payLoad.setEstado({ ...newState });
    payLoad.setStepIndex(3);
    payLoad.stepper.current?.goto(3);

    activarBtnEpayco();
  }else{
    newState.showError = true;
    payLoad.setShowError(true);
    payLoad.setEstado(newState);
    payLoad.setErrorMensaje(response?.data.mensaje || "Error al consultar el pago rápido");
    Swal.fire({
      title: response?.data.mensaje || "Error al consultar el pago rápido",
      icon: 'warning',
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    });
  }
};

const realizarValidaciones = (
  estado: Iestado,
  showError: boolean,
  stepper: React.MutableRefObject<StepperComponent | null>,
  stepIndex: number,
  documentosPago: Idocumento[],
  setErrorMensaje: React.Dispatch<React.SetStateAction<string>>,
  setShowError: React.Dispatch<React.SetStateAction<boolean>>,
  stpb: React.Dispatch<React.SetStateAction<boolean>>,
  setEstado: React.Dispatch<React.SetStateAction<Iestado>>,
  setStepIndex: React.Dispatch<React.SetStateAction<number>>,
  setDocumentosPagoDisponibles: React.Dispatch<
    React.SetStateAction<Idocumento[]>
  >
) => {
  const step = stepper.current?.currentStepIndex;
  //alert(stepIndex + " - " + step);
  setErrorMensaje("");
  setShowError(false);
  if (step === 1) {
    revisarDocumento(
      estado,
      setEstado,
      setErrorMensaje,
      setShowError,
      stpb,
      stepper,
      setStepIndex,
      documentosPago,
      setDocumentosPagoDisponibles
    );
  } else if (step === 2) {
    revisarAbono(
      estado,
      showError,
      setErrorMensaje,
      setShowError,
      stepper,
      setStepIndex
    );
    //revisarReferencia();
    activarBtnEpayco();
  }
};

async function revisarDocumento(
  estado: Iestado,
  setEstado: React.Dispatch<React.SetStateAction<Iestado>>,
  setErrorMensaje: React.Dispatch<React.SetStateAction<string>>,
  setShowError: React.Dispatch<React.SetStateAction<boolean>>,
  stpb: React.Dispatch<React.SetStateAction<boolean>>,
  stepper: React.MutableRefObject<StepperComponent | null>,
  setStepIndex: React.Dispatch<React.SetStateAction<number>>,
  documentosPago: Idocumento[],
  setDocumentosPagoDisponibles: React.Dispatch<
    React.SetStateAction<Idocumento[]>
  >
) {
  const token = await JWT("PAGOS_EN_LINEA");
  var _headers = { Authorization: "Bearer " + token };
  let url = "";
  if(estado.tipoDocumento === "NIT"){
    url = baseUrl_empresa()+estado.documento;
  }else{
    url = baseUrl_trabajador() +
          "/" + estado.documento +
          "&tipoDocumento=" +
          estado.tipoDocumento;
  }

  setErrorMensaje("");
  setShowError(true);
  //VALIDACION DOCUMENTO VACIO
  if (estado.documento.trim() === "") {
    setErrorMensaje("El numero de documento debe diligenciarse primero!");
    setShowError(true);
    stepper.current?.goto(1);
    setStepIndex(1);
    return false;
  }

  const resp = await XHR(stpb, url, {}, "get", _headers);
  //console.log(resp);
  if (resp?.data === null || resp?.data.exito === false || typeof resp?.data.exito === "undefined") {
    setErrorMensaje("Documento erroroneo y/o inexistente");
    setShowError(true);
    stepper.current?.goto(1);
    setStepIndex(1);
  } else if (resp?.data.data.length === 0) {
    setErrorMensaje("Documento erroroneo y/o inexistente");
    setShowError(true);
    stepper.current?.goto(1);
    setStepIndex(1);
  } else {
    setShowError(false);
    stepper.current?.goto(2);
    setStepIndex(2);

    const newState = { ...estado };
    if(estado.tipoDocumento === "NIT"){
      newState.nombres =
        resp?.data.data.nombre1 + " " + resp?.data.data.nombre2;
      newState.apellidos = "";
      newState.telefono = resp?.data.data.telefono;
      newState.direccion = resp?.data.data.dirrecion;

      newState.correo = resp?.data.data.email;
    }else{
      newState.nombres =
        resp?.data.data[0].nombre1 + " " + resp?.data.data[0].nombre2;
      newState.apellidos =
        resp?.data.data[0].apellido1 + " " + resp?.data.data[0].apellido2;
      newState.telefono = resp?.data.data[0].celular;
      newState.direccion = resp?.data.data[0].dirrecion;

      newState.correo = resp?.data.data[0].correoE;
    }
    
    setEstado(newState);
    consultarDocumentosPagoPersona(
      newState,
      stpb,
      documentosPago,
      setDocumentosPagoDisponibles,
      setEstado
    );
  }
}

function revisarAbono(
  estado: Iestado,
  showError: boolean,
  setErrorMensaje: React.Dispatch<React.SetStateAction<string>>,
  setShowError: React.Dispatch<React.SetStateAction<boolean>>,
  stepper: React.MutableRefObject<StepperComponent | null>,
  setStepIndex: React.Dispatch<React.SetStateAction<number>>
) {
  const keys = Object.keys(estado.referencias);
  let errores = 0;
  let vtd = valortotalDocumentosSeleccionados(estado);

  keys.forEach((ref) => {
    let valorMinimo = estado.referencias[ref].valorMinimo;
    let valorMinimoAbono = estado.referencias[ref].valorMinimoAbono;
    let valorMaximo = estado.referencias[ref].valorTotal;
    let valorAbono = estado.referencias[ref].valor_abono;
    let hacer_abono = estado.referencias[ref].hacer_abono;
    let abonable = estado.referencias[ref].abonable;
    let tipopago = estado.referencias[ref].tipoPago;

    valorMinimoAbono = Math.ceil(valorMinimoAbono);
    valorMaximo = valorMaximo === 0 ? valorMinimo : valorMaximo;

    /*console.log(
      valorMinimoAbono,
      valorMinimo,
      valorMaximo,
      valorAbono,
      hacer_abono,
      abonable,
      vtd
    );
    console.log(estado.referencias[ref]);*/
    if (
      (valorAbono < valorMinimoAbono || valorAbono > valorMaximo) &&
      hacer_abono && tipopago === "otr" &&
      abonable
    ) {
      errores++;
    }
  });

  if (vtd === 0) {
    setShowError(true);
    setErrorMensaje("Ingrese un valor mayor a 0!");
    stepper.current?.goto(2);
    setStepIndex(2);
  } else if (errores > 0) {
    setShowError(true);
    setErrorMensaje("Uno de los valores para abono no es valido!");
    stepper.current?.goto(2);
    setStepIndex(2);
  } else {
    setShowError(false);
    setErrorMensaje("");
  }
}

function activarBtnEpayco() {
  const script = document.createElement("script");

  //script.src = "https://checkout.epayco.co/checkout.js";
  script.src = "https://checkout.epayco.co/checkout-v2.js";
  script.async = true;
  script.onload = () => {
    //alert("Moises Bolaño");
  };
  script.onclick = () => {
    alert("Click btn epayco");
  };

  document.querySelector("#targetEpayco")?.appendChild(script);

  document.body.appendChild(script);
}

//console.log(process.env.REACT_APP_AMBIENTE_EPAYCO);

export {
  cargarDatosMaestros,
  //eventoPagoServicios,
  consultarDocumentosPagoPersona,
  consultarPagoRapido,
  activarBtnEpayco,
  realizarValidaciones,
  defaultState,
};
